import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const KriptoTerimler = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('kriptoTerimler.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <h3 className="academy-subtitle">{t('kriptoTerimler.subtitle')}</h3>
                        <p className="academy-intro-text">{t('kriptoTerimler.intro.p1')}</p>
                        <p className="academy-intro-text fw-bold">{t('kriptoTerimler.intro.p2')}</p>
                        <ul className="academy-list">
                            {t('kriptoTerimler.intro.features', { returnObjects: true }).map((feature, index) => (
                                <li key={index}>{feature}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Alfabetik Terimler */}
                {t('kriptoTerimler.sections', { returnObjects: true }).map((section, sectionIndex) => (
                    <div className={`academy-section ${sectionIndex % 2 === 0 ? '' : ''}`} key={sectionIndex}>
                        <div className="container">
                            <h2 className="academy-section-title">{section.letter}</h2>
                            
                            {section.terms.map((term, termIndex) => (
                                <div className="academy-highlight-box mb-3" key={termIndex}>
                                    <h5 className="text-primary">{term.term}</h5>
                                    <p className="mb-0">{term.definition}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                {/* Kripto Kültürü ve Slang */}
                <div className="academy-section mb-5 mt-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoTerimler.culture.title')}</h2>
                        <p className="academy-section-text">{t('kriptoTerimler.culture.intro')}</p>
                        
                        {t('kriptoTerimler.culture.terms', { returnObjects: true }).map((term, index) => (
                            <div className="academy-type-card mb-3" key={index}>
                                <h5>{term.term}</h5>
                                <p className="mb-0">{term.definition}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Kripto Emojileri */}
                <div className="academy-section mb-5 mt-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoTerimler.emojis.title')}</h2>
                        <p className="academy-section-text">{t('kriptoTerimler.emojis.intro')}</p>
                        
                        <div className="row g-4">
                            {t('kriptoTerimler.emojis.list', { returnObjects: true }).map((emoji, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-advantage-card">
                                        <h4 className="mb-2">{emoji.emoji} {emoji.name}</h4>
                                        <p className="mb-0">{emoji.meaning}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Nasıl Kullanılır? */}
                <div className="academy-section mb-5 mt-5">
                    <div className="container mb-5">
                        <h2 className="academy-section-title">{t('kriptoTerimler.usage.title')}</h2>
                        <p className="academy-section-text">{t('kriptoTerimler.usage.intro')}</p>
                        
                        <ol className="academy-list">
                            {t('kriptoTerimler.usage.tips', { returnObjects: true }).map((tip, index) => (
                                <li key={index}>{tip}</li>
                            ))}
                        </ol>

                        <div className="academy-example-box mt-4 mb-5">
                            <h5>{t('kriptoTerimler.usage.example.title')}</h5>
                            <p className="fw-bold">{t('kriptoTerimler.usage.example.sentence')}</p>
                            <p><strong>{t('kriptoTerimler.usage.example.meaningLabel')}</strong></p>
                            <p className="mb-0">{t('kriptoTerimler.usage.example.meaning')}</p>
                        </div>

                        <div className="academy-highlight-box bg-info text-white mt-4">
                            <p className="mb-0"><strong>{t('kriptoTerimler.usage.note.title')}</strong> {t('kriptoTerimler.usage.note.text')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Cta1 
            title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}/>
        </div>
    );
};

export default KriptoTerimler;
